import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 relative" data-id="element-78">
      {/* Background Effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-900/10 to-transparent pointer-events-none" data-id="element-79" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-3xl p-1 md:p-[2px] bg-gradient-to-b from-emerald-500/50 to-transparent overflow-hidden box-glow" data-id="element-81">
          <div className="bg-[#0f1a14] rounded-[22px] p-8 md:p-12 h-full w-full relative overflow-hidden" data-id="element-82">
            {/* Inner subtle glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-64 bg-emerald-500/10 blur-[80px] pointer-events-none" data-id="element-83" />

            <div className="relative z-10 text-center" data-id="element-84">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-semibold tracking-wider uppercase mb-8" data-id="element-85">
                <Zap className="w-4 h-4" data-id="element-86" />
                La Solución
              </div>

              <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-87">
                El Reseteo de Respuesta Mitocondrial (RRM)
              </h2>

              <p className="text-lg md:text-xl text-gray-300 leading-relaxed text-left md:text-center" data-id="element-88">
                Este protocolo no se basa en "forzar" al cuerpo, sino en
                enviarle señales químicas de seguridad y abundancia. A través de
                micro-estímulos específicos de luz, temperatura y orden
                nutricional, convencemos a tus células de que es seguro volver a
                producir ATP (energía) a máxima potencia. Es una reingeniería de
                tu sistema operativo biológico diseñada específicamente para la
                fisiología de más de 40 años.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}